import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import RaisedButton from "material-ui/RaisedButton";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import update from "immutability-helper";
import Field from "components/Form/Field";
import Delete from "../Buttons/Delete";

import * as actions from "../../data/providers/actions";

class TargetEditor extends React.Component {
  state = {
    value: {}
  };

  componentWillReceiveProps = e => {
    this.setState({
      value: e.value
    });
  };

  componentWillMount() {
    this.props.fetchProviders();
  }

  static contextTypes = {
    router: PropTypes.object
  };

  handleDeleteClick = (parentkey, id) => {
    const next = update(this.state, {
      value: {
        [parentkey]: {
          domains: {
            [id]: { $set: undefined }
          }
        }
      }
    });
    delete next.value[parentkey].domains[id];

    this.setState(next);
  };

  handleGroupDeleteClick = id => {
    const next = update(this.state, {
      value: {
        [id]: { $set: undefined }
      }
    });
    delete next.value[id];

    this.setState(next);
  };

  handleAddDomainClick = key => {
    var did = "id" + new Date().valueOf();

    var next = this.state;
    if (!next.value[key].domains) {
      next = update(next, {
        value: {
          [key]: { $merge: { domains: {} } }
        }
      });
    }

    next = update(next, {
      value: {
        [key]: {
          domains: {
            $merge: { [did]: { label: "", value: "" } }
          }
        }
      }
    });
    this.setState(next);
  };

  handleDomainLabelChange = (parentkey, id, field) => {
    const next = update(this.state, {
      value: {
        [parentkey]: {
          domains: {
            [id]: { $merge: { label: field.state.value } }
          }
        }
      }
    });
    this.setState(next);
  };

  handleDomainValueChange = (parentkey, id, field) => {
    const next = update(this.state, {
      value: {
        [parentkey]: {
          domains: {
            [id]: { $merge: { value: field.state.value } }
          }
        }
      }
    });
    this.setState(next);
  };

  handleDomainValueChange;

  handleAddGroup = () => {
    var id = "id" + new Date().valueOf();
    var newgroup = {
      value: { [id]: { name: "", unit: "", chart: "", domains: {} } }
    };
    var next = _.merge({}, this.state, newgroup);
    this.setState(next);
  };

  handleGroupNameChange = (key, field) => {
    const next = update(this.state, {
      value: {
        [key]: {
          name: { $set: field.state.value }
        }
      }
    });
    this.setState(next);
  };

  handleGroupUnitChange = (key, event, index, value) => {
    const next = update(this.state, {
      value: {
        [key]: {
          unit: { $set: value }
        }
      }
    });
    this.setState(next);
  };

  handleGroupChartChange = (key, event, index, value) => {
    const next = update(this.state, {
      value: {
        [key]: {
          chart: { $set: value }
        }
      }
    });
    this.setState(next);
  };

  handleGroupProviderChange = (key, event, index, value) => {
    const next = update(this.state, {
      value: {
        [key]: {
          providerid: { $set: value }
        }
      }
    });
    this.setState(next);
  };

  renderTargets = () => {
    return _.map(this.state.value, (target, key) => {
      return (
        <div key={key} className="targeteditor__group">
          <div className="targeteditor__group__details">
            <Field
              handleChange={this.handleGroupNameChange.bind(this, key)}
              value={target.name}
              floatingLabelText="Grupp"
            />
            <SelectField
              value={target.unit}
              onChange={this.handleGroupUnitChange.bind(this, key)}
              floatingLabelText="Värdetyp"
            >
              <MenuItem value="individer" primaryText="Individer" />
              <MenuItem value="st" primaryText="Antal" />
              <MenuItem value="procent" primaryText="Procent" />
              <MenuItem value="sek" primaryText="Kronor" />
            </SelectField>
            <SelectField
              value={target.chart}
              onChange={this.handleGroupChartChange.bind(this, key)}
              floatingLabelText="Visa som"
            >
              <MenuItem value="circle" primaryText="Cirkeldiagram" />
              <MenuItem value="bar" primaryText="Stapeldiagram" />
              <MenuItem value="line" primaryText="Linjediagram" />
              <MenuItem value="text" primaryText="Text information" />
            </SelectField>

            <SelectField
              floatingLabelText="Leverantör"
              value={target.providerid}
              onChange={this.handleGroupProviderChange.bind(this, key)}
            >
              {_.map(this.props.providers, (opt, key) => (
                <MenuItem key={key} value={key} primaryText={opt.name} />
              ))}
            </SelectField>

            <span>
              <Delete
                handleClick={this.handleGroupDeleteClick.bind(this, key)}
              />
            </span>
          </div>
          <div className="targeteditor__domains">
            {this.renderTargetDomain(key, target)}
            <RaisedButton
              label="Lägg till rad"
              onTouchTap={this.handleAddDomainClick.bind(this, key)}
            />
          </div>
        </div>
      );
    });
  };

  renderTargetDomain = (parentkey, target) => {
    return _.map(target.domains, (domain, key) => {
      if (!domain) return null;

      return (
        <div key={key} className="targeteditor__domain">
          <Field
            handleChange={this.handleDomainLabelChange.bind(
              this,
              parentkey,
              key
            )}
            value={domain.label}
            floatingLabelText="Intervall"
          />
          <Field
            handleChange={this.handleDomainValueChange.bind(
              this,
              parentkey,
              key
            )}
            value={domain.value}
            floatingLabelText="Värde"
          />
          <span>
            <Delete
              handleClick={this.handleDeleteClick.bind(this, parentkey, key)}
            />
          </span>
        </div>
      );
    });
  };

  render() {
    return (
      <div className="targeteditor">
        <RaisedButton
          primary={true}
          label="Lägg till ny grupp"
          onClick={this.handleAddGroup}
        />
        {this.renderTargets()}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    providers: state.providers.list.data
  };
}

export default connect(mapStateToProps, actions, null, { withRef: true })(
  TargetEditor
);



// WEBPACK FOOTER //
// ./src/components/Form/TargetEditor.jsx